import { shallowRef } from 'vue'

/**
 * Drawer open state, deliberately module-scoped rather than provided.
 *
 * There is exactly one drawer, mounted once in App.vue, and it is opened from
 * AppScreen's leading control on whichever screen is current. Threading it via
 * provide/inject would mean every screen re-declaring an inject just to pass it
 * along to its own header.
 *
 * The drawer is NOT a route. Routing it would make the Android back gesture close
 * the drawer instead of leaving the screen, and users read an overlay as a layer,
 * not as a place they navigated to.
 */
const open = shallowRef(false)

export function useAppDrawer() {
  return {
    open,
    openDrawer: () => {
      open.value = true
    },
    closeDrawer: () => {
      open.value = false
    },
  }
}
